import api from "./api";

export type FinancialYear = {
  id: string;
  code: string;
  label: string;
  startDate: string;
  endDate: string;
  isCurrent: boolean;
  isClosed?: boolean;
  closedAt?: string | null;
  closedBy?: string | null;
};

export function indiaFyMeta(date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const startYear = m >= 4 ? y : y - 1;
  const endYear = startYear + 1;
  const yy1 = String(startYear).slice(-2);
  const yy2 = String(endYear).slice(-2);
  const label = `${startYear}-${yy2}`;
  return {
    code: `FY${yy1}${yy2}`,
    label,
    /** UI display: FY 2026-27 */
    display: `FY ${label}`,
    startDate: `${startYear}-04-01`,
    endDate: `${endYear}-03-31`,
  };
}

/** Prefer API label → "FY 2026-27"; fallback from code FY2627. */
export function formatFinancialYearDisplay(fy?: {
  code?: string | null;
  label?: string | null;
  isClosed?: boolean;
} | null): string {
  if (fy?.label) {
    const label = String(fy.label).trim();
    const base = label.toUpperCase().startsWith("FY") ? label : `FY ${label}`;
    return fy.isClosed ? `${base} (closed)` : base;
  }
  const code = String(fy?.code || "").trim().toUpperCase();
  const m = code.match(/^FY(\d{2})(\d{2})$/);
  if (m) {
    const start = 2000 + parseInt(m[1], 10);
    const base = `FY ${start}-${m[2]}`;
    return fy?.isClosed ? `${base} (closed)` : base;
  }
  return indiaFyMeta().display;
}

const financialYearAPI = {
  list: async (): Promise<FinancialYear[]> => {
    const res = await api.get("/financial-years");
    return res.data?.data || [];
  },
  current: async (): Promise<FinancialYear | null> => {
    const res = await api.get("/financial-years/current");
    return res.data?.data || null;
  },
  close: async (id: string): Promise<FinancialYear> => {
    const res = await api.post(`/financial-years/${id}/close`);
    return res.data?.data;
  },
  reopen: async (id: string): Promise<FinancialYear> => {
    const res = await api.post(`/financial-years/${id}/reopen`);
    return res.data?.data;
  },
};

export default financialYearAPI;
